import { Link, useNavigate } from "react-router-dom";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { supabase } from "@/integrations/supabase/client";
import { LogOut, HelpCircle, Award, Info, FileText, Cookie, Mail, Shield } from "lucide-react";

interface MobileMoreMenuProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileMoreMenu({ open, onOpenChange }: MobileMoreMenuProps) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
    onOpenChange(false);
  };

  const menuItems = [
    { icon: HelpCircle, label: 'FAQ', path: '/faq' },
    { icon: Award, label: 'Vorteile', path: '/vorteile' },
    { icon: Info, label: 'Über uns', path: '/about' },
    { icon: FileText, label: 'Impressum', path: '/impressum' },
    { icon: Shield, label: 'Datenschutz', path: '/datenschutz' },
    { icon: FileText, label: 'AGB', path: '/agb' },
    { icon: Cookie, label: 'Cookies', path: '/cookies' },
    { icon: Mail, label: 'Kontakt', path: '/kontakt' },
  ];

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="h-[80vh] rounded-t-2xl">
        <SheetHeader>
          <SheetTitle>Mehr</SheetTitle>
        </SheetHeader>
        
        <div className="mt-6 space-y-2">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => onOpenChange(false)}
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-accent transition-colors touch-target"
            >
              <item.icon className="w-5 h-5 text-muted-foreground" />
              <span className="text-base">{item.label}</span>
            </Link>
          ))}
          
          <Separator className="my-4" />
          
          <Button
            variant="ghost"
            className="w-full justify-start gap-3 touch-target"
            onClick={handleLogout}
          >
            <LogOut className="w-5 h-5 text-destructive" />
            <span className="text-base">Abmelden</span>
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
